// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")

var jQuery = require("jquery");
global.$ = global.jQuery = jQuery;
window.$ = window.jQuery = jQuery;

require('bootstrap');
require('admin-lte');
require('select2');

import './stylesheet.js';

var cocoon = require('./cocoon.js');
cocoon.default(jQuery);

var utils = require('./utils.js');
utils.default(jQuery);

window.poloni = { utils: {} }
window.poloni.utils.select2_ajax = require('./utils/select2_ajax.js').default;

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%#= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

require("trix")
require("@rails/actiontext");

document.addEventListener("turbolinks:load", function () {

  function applyToggle(input) {
    const nested = input.closest(".nested-fields") || document
    const targetSelector = input.dataset.toggleTarget
    if (!targetSelector) return

    const targets = nested.querySelectorAll(targetSelector)
    if (!targets.length) return

    const val = (input.type === "checkbox") ? (input.checked ? "true" : "false") : input.value

    const showWhen = input.dataset.toggleShowWhen
    const hideWhen = input.dataset.toggleHideWhen

    let shouldShow = true

    if (showWhen !== undefined) shouldShow = (val === showWhen)
    if (hideWhen !== undefined) shouldShow = (val !== hideWhen)

    targets.forEach((t) => {
      t.classList.toggle("d-none", !shouldShow)
    })
  }

  function setupToggles(root = document) {
    root.querySelectorAll(".js-toggle").forEach((input) => {
      if (input.dataset.toggleBound === "1") return
      input.dataset.toggleBound = "1"

      const handler = () => applyToggle(input)
      handler()
      input.addEventListener("change", handler)
    })
  }

  setupToggles()

  $(document).on("cocoon:after-insert", function (e, insertedItem) {
    setupToggles(insertedItem[0])
  })
})